/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalTime
 */
export interface LocalTime {
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    hour?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    minute?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    second?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    nano?: number;
}

/**
 * Check if a given object implements the LocalTime interface.
 */
export function instanceOfLocalTime(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LocalTimeFromJSON(json: any): LocalTime {
    return LocalTimeFromJSONTyped(json, false);
}

export function LocalTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalTime {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hour': !exists(json, 'hour') ? undefined : json['hour'],
        'minute': !exists(json, 'minute') ? undefined : json['minute'],
        'second': !exists(json, 'second') ? undefined : json['second'],
        'nano': !exists(json, 'nano') ? undefined : json['nano'],
    };
}

export function LocalTimeToJSON(value?: LocalTime | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hour': value.hour,
        'minute': value.minute,
        'second': value.second,
        'nano': value.nano,
    };
}

